import { render, staticRenderFns } from "./CompanyDetail.vue?vue&type=template&id=56ecbfed&scoped=true&"
import script from "./CompanyDetail.vue?vue&type=script&lang=js&"
export * from "./CompanyDetail.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDetail.vue?vue&type=style&index=0&id=56ecbfed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ecbfed",
  null
  
)

export default component.exports